function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Tab INSTEAD.

import React, { Component } from 'react';
import { isEmpty, isEqual, noop } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @visibleName Tab DEPRECATED
*/
var Tab = /*#__PURE__*/function (_Component) {
  function Tab(props) {
    var _this;
    _classCallCheck(this, Tab);
    _this = _callSuper(this, Tab, [props]);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    return _this;
  }
  _inherits(Tab, _Component);
  return _createClass(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        activeTab = _this$props.activeTab,
        value = _this$props.value,
        children = _this$props.children;
      if (isEqual(activeTab, value)) {
        this.setContent(children);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var activeTab = nextProps.activeTab,
        value = nextProps.value,
        children = nextProps.children;
      if (!isEqual(activeTab, this.props.activeTab) && isEqual(activeTab, value)) {
        this.setContent(children);
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      event.preventDefault();
      if (event.charCode === 13 || event.charCode === 32) {
        this.props.onChange(this.props.value);
      }
    }
  }, {
    key: "setContent",
    value: function setContent(children) {
      var childrenElement = isEmpty(children) ? null : children;
      this.props.setContent(childrenElement);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        className = _this$props2.className,
        style = _this$props2.style,
        activeTab = _this$props2.activeTab,
        value = _this$props2.value,
        label = _this$props2.label,
        dataTestId = _this$props2.dataTestId;
      var tabClass = function tabClass() {
        return classNames({
          'ui-tab': true,
          'ui-tab--active': activeTab === value
        }, className);
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "ui-tab-container"
      }, /*#__PURE__*/React.createElement("button", {
        id: id,
        className: tabClass(),
        style: style,
        onClick: function onClick() {
          return _this2.props.onChange(value);
        },
        role: "tab",
        tabIndex: 0,
        onKeyPress: this.onKeyPress,
        "aria-current": isEqual(activeTab, value),
        "aria-label": "".concat(label, " tab"),
        "data-testid": dataTestId,
        "aria-selected": activeTab
      }, /*#__PURE__*/React.createElement("div", {
        className: "ui-tab__label"
      }, label)));
    }
  }]);
}(Component);
Tab.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Sets the text value of the tab item to the string specified. */
  label: PropTypes.string.isRequired,
  /** If value prop passed to Tabs component, this value prop is also required. It assigns a value to the tab so that it can be selected by the Tabs. */
  value: PropTypes.string.isRequired,
  /** Immutable identifier for testing */
  dataTestId: PropTypes.string,
  /**
   * Called when the selected value change.
   * @ignore
   */
  onChange: PropTypes.func.isRequired,
  /**
   * active tab value
   * @ignore
   */
  activeTab: PropTypes.string,
  /**
   * set Content on active Tab
   * @ignore
   */
  setContent: PropTypes.func,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node
};
Tab.defaultProps = {
  id: '',
  className: '',
  style: {},
  children: [],
  setContent: noop,
  activeTab: '',
  dataTestId: ''
};
export default Tab;